module.exports = __webpack_public_path__ + "media/images/lb/602-a90d5fea9b3d2060fedde94d6b34b282.svg";